import { useStaticQuery, graphql } from "gatsby"

const useLatestPosts = () => {
  const { articleAu, caseStudyAu, companyNewsAu, articleNz, caseStudyNz, companyNewsNz } = useStaticQuery(graphql`
    query LatestNews {
      site {
        buildTime(formatString: "YYYY-MM-DD")
      }
      articleNz: allWpPost(
        filter: {
          types: {
            nodes: {
              elemMatch: {
                slug: {
                  eq: "product-focus"
                }
              }
            }
          }
          sites: {
						nodes:{
							elemMatch: { slug: { eq: "new-zealand" } } 
            }
          } 
        }
        sort: {date: DESC}
        limit: 1
      )
      {
        nodes {
          ...ArticleCard
        }
      }
      caseStudyNz: allWpPost(
        filter: {
          types: {
            nodes: {
              elemMatch: {
                slug: {
                  eq: "case-study"
                }
              }
            }
          }
          sites: {
						nodes:{
							elemMatch: { slug: { eq: "new-zealand" } } 
            }
          } 
        }
        sort: {date: DESC}
        limit: 1
      )
      {
        nodes {
          ...ArticleCard
        }
      }
      companyNewsNz: allWpPost(
        filter: {
          types: {
            nodes: {
              elemMatch: {
                slug: {
                  eq: "company-news"
                }
              }
            }
          }
          sites: {
						nodes:{
							elemMatch: { slug: { eq: "new-zealand" } } 
            }
          } 
        }
        sort: {date: DESC}
        limit: 1
      )
      {
        nodes {
          ...ArticleCard
        }
      }
      articleAu: allWpPost(
        filter: {
          types: {
            nodes: {
              elemMatch: {
                slug: {
                  eq: "product-focus"
                }
              }
            }
          }
          sites: {
						nodes:{
							elemMatch: { slug: { eq: "australia" } } 
            }
          } 
        }
        sort: {date: DESC}
        limit: 1
      )
      {
        nodes {
          ...ArticleCard
        }
      }
      caseStudyAu: allWpPost(
        filter: {
          types: {
            nodes: {
              elemMatch: {
                slug: {
                  eq: "case-study"
                }
              }
            }
          }
          sites: {
						nodes:{
							elemMatch: { slug: { eq: "australia" } } 
            }
          } 
        }
        sort: {date: DESC}
        limit: 1
      )
      {
        nodes {
          ...ArticleCard
        }
      }
      companyNewsAu: allWpPost(
        filter: {
          types: {
            nodes: {
              elemMatch: {
                slug: {
                  eq: "company-news"
                }
              }
            }
          }
          sites: {
						nodes:{
							elemMatch: { slug: { eq: "australia" } } 
            }
          } 
        }
        sort: {date: DESC}
        limit: 1
      )
      {
        nodes {
          ...ArticleCard
        }
      }
    }
  `)

  if (process.env.GATSBY_WP_CATEGORY_SITE_SLUG === 'new-zealand') {
    return [...articleNz.nodes, ...companyNewsNz.nodes, ...caseStudyNz.nodes]
  }

  return [...articleAu.nodes, ...companyNewsAu.nodes, ...caseStudyAu.nodes]
}

export default useLatestPosts